(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    /* Mobile navigation bar: open the submenu in place instead of navigating */
  (function () {
    if (window.__mnavBound) return;
    window.__mnavBound = true;

    function closeAll(root, except) {
      root.querySelectorAll('.mnav-toggle').forEach(function (b) {
        if (b !== except) b.setAttribute('aria-expanded', 'false');
      });
      root.querySelectorAll('.mnav-panel').forEach(function (p) {
        p.hidden = true;
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.mnav-toggle') : null;

      if (!btn) {
        /* tap outside closes any open panel */
        if (!(e.target.closest && e.target.closest('.mnav-panel'))) {
          document.querySelectorAll('.menu-list--mobile').forEach(function (r) {
            closeAll(r, null);
          });
        }
        return;
      }

      e.preventDefault();
      var root = btn.closest('.menu-list--mobile');
      if (!root) return;

      var key = btn.getAttribute('data-mnav-target');
      var panel = root.querySelector('[data-mnav-panel="' + key + '"]');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      closeAll(root, btn);

      if (isOpen) {
        btn.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      } else {
        btn.setAttribute('aria-expanded', 'true');
        if (panel) {
          panel.hidden = false;
          try {
            btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          } catch (err) {
            /* older browsers */
          }
        }
      }
    });

    /* only one nested accordion open at a time inside a panel */
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.classList || !d.classList.contains('mnav-d') || !d.open) return;
      var panel = d.closest('.mnav-panel');
      if (!panel) return;
      panel.querySelectorAll('details.mnav-d[open]').forEach(function (o) {
        if (o !== d) o.open = false;
      });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
